/** El logotipo `)·(` de Sinapser, tal cual está en los mockups de plan/design/. */
export function Marca({ tamano = 20 }: { readonly tamano?: number }) {
  return (
    <svg width={tamano} height={tamano} viewBox='0 0 100 100' aria-hidden='true'>
      <path
        d='M25 10 C37 24, 40 37, 40 50 C40 63, 37 76, 25 90 Q19 88 15 83 C31 71, 34 60, 34 50 C34 40, 31 29, 15 17 Q19 12 25 10 Z'
        fill='currentColor'
      />
      <path
        d='M75 10 C63 24, 60 37, 60 50 C60 63, 63 76, 75 90 Q81 88 85 83 C69 71, 66 60, 66 50 C66 40, 69 29, 85 17 Q81 12 75 10 Z'
        fill='currentColor'
      />
      <circle cx='50' cy='50' r='7.5' fill='var(--teal)' />
    </svg>
  );
}
